import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { MappableImportWizard } from 'common-front/src/import/mappableImportWizard';
import { CustomFieldVariety } from 'common/src/generated/types';
import { PositionsImportInputService } from 'common/src/input/positionsImportInput';
import { PositionsPaths } from 'common/src/util/paths/positionsPaths';
import * as React from 'react';
import {
    useOrganizationImportInfosQuery,
    usePositionsImportMutation
} from '../../../generated/graphqlHooks';
import { useNotificationContext } from '../../../notifications/notificationContext';

export const PositionsCsvImport = () => {
    const {
        params: { organizationId, eventId },
        translate
    } = useHeavent();
    const { mutate } = usePositionsImportMutation();
    const { checkPositionsImport } = useNotificationContext();
    const { data, loader } = useOrganizationImportInfosQuery({
        organizationId,
        variety: CustomFieldVariety.Position
    });

    return (
        loader || (
            <MappableImportWizard
                ImportInputService={PositionsImportInputService}
                checkImport={checkPositionsImport}
                closePath={PositionsPaths.POSITIONS({ organizationId, eventId })}
                customFields={data.organization.customFields.nodes}
                importTagPrefix="positions"
                itemName={{ singular: translate('task_24074'), plural: translate('tasks_06050') }}
                localStorageKeyPrefix="POSITIONS_IMPORT"
                mutate={mutate}
                showModeSelection={false}
                title={translate('importing_tasks_31757')}
            />
        )
    );
};
